import { createTheme } from "@mui/material/styles";

const theme =  createTheme({
  palette: {
    primary: {
      main: '#1E88E5', // Example primary color
    },
    secondary: {
      main: '#FF4081', // Example secondary color
    },
  },
});
export default theme;
